import { BrowserCacheLocation, Configuration } from '@azure/msal-browser';

function getBrowserOrigin() {
  return window.location.origin;
}

export function shouldUseRedirectLogin() {
  return process.env.REACT_APP_USE_REDIRECT_LOGIN === 'true';
}

export function getLoginRedirectUri() {
  return process.env.REACT_APP_AAD_REDIRECT_URI || getBrowserOrigin();
}

export function getPopupRedirectUri() {
  return process.env.REACT_APP_AAD_POPUP_REDIRECT_URI || `${getBrowserOrigin()}/blank.html`;
}

export const authConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AAD_CLIENT_ID || '',
    authority: process.env.REACT_APP_AAD_AUTHORITY || '',
    redirectUri: getLoginRedirectUri(),
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: false,
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [`api://${process.env.REACT_APP_WEB_API_ID}/CarSharing.Access.All`],
};
